import { render, staticRenderFns } from "./EditMarkupPage.vue?vue&type=template&id=caa64c1e&scoped=true&"
import script from "./EditMarkupPage.vue?vue&type=script&lang=ts&"
export * from "./EditMarkupPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditMarkupPage.vue?vue&type=style&index=0&id=caa64c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa64c1e",
  null
  
)

export default component.exports